import { motion } from 'framer-motion';

const containerVariants = {
  initial: { opacity: 1 },
  exit: { 
    opacity: 0, 
    transition: { duration: 0.5, ease: 'easeInOut' }
  },
};

export const Preloader = () => {
  return (
    <motion.div
      variants={containerVariants}
      initial="initial"
      exit="exit"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-beige"
    >
      <motion.img
        src="/images/logo/INS_1_192.png"
        srcSet="/images/logo/INS_1_192.png 192w, /images/logo/INS_1_512.png 512w"
        sizes="(min-width: 768px) 160px, 160px"
        alt="INS Organization"
        width={160}
        height={160}
        decoding="async"
        loading="eager"
        className="h-16 w-auto md:h-20 drop-shadow animate-pulse"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: [0.95, 1, 0.95] }}
        transition={{ duration: 1.6, ease: 'easeInOut', repeat: Infinity }}
      />
    </motion.div>
  );
};
